<template>
  <div class="content has_breadcrumb studentResponse" v-loading="loading">
    <base-breadcrumb
      style="position: fixed; background-color: #fff; z-index: 10"
      :data="[
        {
          routeName: 'locations',
          name: user.schoolName
        },
        {
          routeName: 'commbook',
          name: 'Commbook'
        },
        {
          routeName: 'commbookStudent',
          name: `${firstName} ${$route.query.lastName}`
        },
        {
          name: `${dataList.title}`
        }
      ]"
      slot="breadcrumb"
    />
    <GgPage pageType="1" title="Commbook" class="commbook">
      <div class="response" v-if="dataList">
        <div class="response-header">
          <p class="title" ref="titleH">{{ dataList.title }}</p>
          <p class="type">{{ dataList.topic }}</p>
        </div>
        <div
          class="msgs"
          id="scrollDiv"
          :style="{
            height:
              fileList.length > 0
                ? `calc(100vh - 350px - 70px - ${editorHeightC} - ${titleHeight})`
                : `calc(100vh - 350px - ${editorHeightC} - ${titleHeight})`
          }"
        >
          <div class="msg" v-if="dataList.deleted != 1">
            <div class="msg-header">
              <div class="avatar">
                <head-img
                  :src="dataList.photo"
                  :firstName="dataList.pubUserFirstname"
                  :lastName="dataList.pubUserLastname"
                  line-height="32"
                  @click="() => {}"
                ></head-img>
              </div>
              <span class="name" style="margin-right: 8px">{{
                dataList.pubUserType == 1
                  ? dataList.pubUserFirstname
                  : dataList.pubUserFirstname + ' ' + dataList.pubUserLastname
              }}</span>
              <span class="date"
                >{{ timeFormat(dataList.createTime) }}
                <span style="margin-left: 10px" v-if="dataList.deleted == 2">Edited</span></span
              >
              <span class="dot" v-if="dataList.isRead === 0"></span>
              <span
                class="menu"
                v-if="
                  dataList.pubUserId == user.userId &&
                  Date.now() -
                    Date.parse(
                      UTCDateToLocalDate(dataList.modifyTime) ||
                        UTCDateToLocalDate(dataList.createTime)
                    ) <=
                    1000 * 60 * 60
                "
              >
                <md-menu md-direction="bottom-end">
                  <md-button class="md-icon-button" md-menu-trigger>
                    <i class="iconfont iconmore_vert-24px" />
                  </md-button>
                  <md-menu-content>
                    <md-menu-item
                      v-if="
                        $buttonPermission('Messages', 'Full') ||
                        $buttonPermission('Messages', 'Edit')
                      "
                      @click="onEditConversationSave(dataList)"
                      :disabled="
                        Date.now() -
                          Date.parse(
                            UTCDateToLocalDate(dataList.modifyTime) ||
                              UTCDateToLocalDate(dataList.createTime)
                          ) >
                        1000 * 60 * 60
                      "
                      >Edit</md-menu-item
                    >
                    <md-menu-item
                      v-if="$buttonPermission('Messages', 'Full')"
                      @click="onDelTopic(dataList.id)"
                      :disabled="
                        Date.now() -
                          Date.parse(
                            UTCDateToLocalDate(dataList.modifyTime) ||
                              UTCDateToLocalDate(dataList.createTime)
                          ) >
                          1000 * 60 * 60 || dataList.responseDTOList.length > 0
                      "
                      >Delete</md-menu-item
                    >
                  </md-menu-content>
                </md-menu>
              </span>
            </div>
            <div class="msg-cot">
              <div
                v-if="dataList._isEdit == true"
                class="richT richT1"
                v-loading="dataList.loading"
              >
                <!--              <div class="send" @click="onReply" :class="{send1:replyData}" :style="{bottom:fileList.length?'88px':'8px'}">Send</div>-->
                <RichText
                  :key="'message-' + dataList.id + '-' + dataList._editSession"
                  :content="dataList._message"
                  v-on="dataList._editorEvents"
                  :enable-video="true"
                  :isSureBtnDisabled="!!dataList.loading"
                  :inert="dataList.loading ? '' : null"
                  contentHeight="160px"
                  height="110px"
                  class="richText"
                  :class="{ 'editor-disabled': dataList.loading }"
                  :upload="true"
                  :ref="'richTextMessage'"
                >
                </RichText>
                <div class="errorTxt edit-error" v-if="contentError(dataList._message)">
                  {{ contentError(dataList._message) }}
                </div>
                <div class="upData" v-if="dataList._fileObject && dataList._fileObject.length > 0">
                  <div v-for="(file, ind) in dataList._fileObject" :key="ind" class="upCon">
                    <div class="upCon-c1">
                      <img
                        v-if="
                          file.src && (file.src.indexOf('png') > -1 || file.src.indexOf('jpg') > -1)
                        "
                        :src="file.src"
                        alt=""
                      />
                      <i v-else class="iconfont iconupload"></i>
                    </div>
                    <div class="upCon-c2">
                      <p class="upName">{{ file.fileName }}</p>
                      <p class="upSize" v-if="file.size">({{ Math.floor(file.size / 1024) }}K)</p>
                    </div>
                    <div class="upCon-c3">
                      <el-button
                        type="text"
                        icon="el-icon-close"
                        @click="clearItemFileMessage(ind)"
                      ></el-button>
                    </div>
                    <!--          {{file.fileName}}-->
                  </div>
                </div>
                <div class="btns">
                  <div class="btns-cancel" @click="canceldataList()">Cancel</div>

                  <div
                    class="btns-save"
                    @click="savedataList()"
                    :aria-disabled="!canSaveMessage"
                    :class="{
                      'btns-save1': canSaveMessage
                    }"
                  >
                    Save
                  </div>
                </div>
              </div>
              <div class="txts" v-else v-html="getMessage(dataList)"></div>
            </div>
            <div class="msg-file" v-if="dataList.fileObject && !dataList._isEdit">
              <div
                v-for="(file, index) in parseFileObject(dataList.fileObject)"
                :key="index"
                class="upCon"
                @click="toDown(file.src)"
              >
                <div class="upCon-c1">
                  <img
                    v-if="
                      file.src && (file.src.indexOf('png') > -1 || file.src.indexOf('jpg') > -1)
                    "
                    :src="file.src"
                    alt=""
                  />
                  <i v-else class="iconfont iconupload"></i>
                </div>
                <el-tooltip
                  popper-class="customer-number-tooltip-popover table-tooltip"
                  :content="file.fileName"
                  placement="top"
                  :visible-arrow="false"
                >
                  <div class="upCon-c2">
                    <p class="upName">{{ file.fileName }}</p>
                  </div>
                </el-tooltip>
                <div class="upCon-c3">
                  <p class="upSize" v-if="file.size">({{ Math.floor(file.size / 1024) }}K)</p>
                </div>
                <!--          {{file.fileName}}-->
              </div>
            </div>
          </div>
          <div
            class="msg"
            :key="resItem.id"
            v-if="dataList.responseDTOList.length > 0"
            v-for="(resItem, index) of dataList.responseDTOList"
          >
            <div class="msg-header">
              <div class="avatar">
                <head-img
                  :src="resItem.photo"
                  :firstName="resItem.responseUserFirstname"
                  :lastName="resItem.responseUserLastname"
                  line-height="32"
                  @click="() => {}"
                ></head-img>
              </div>
              <span class="name">{{
                resItem.responseUserType == 1
                  ? resItem.responseUserFirstname
                  : resItem.responseUserFirstname + ' ' + resItem.responseUserLastname
              }}</span>
              <span class="date"
                >{{ timeFormat(resItem.modifyTime) || timeFormat(resItem.createTime)
                }}<span style="margin-left: 10px" v-if="resItem.modifyTime != resItem.createTime"
                  >Edited</span
                ></span
              >
              <span class="dot" v-if="resItem.isRead === 0"></span>
              <span
                class="menu"
                v-if="
                  ($buttonPermission('Messages', 'Full') ||
                    $buttonPermission('Messages', 'Edit')) &&
                  resItem.responseUser == user.userId &&
                  resItem.deleted != 1 &&
                  Date.now() -
                    Date.parse(
                      UTCDateToLocalDate(resItem.modifyTime) ||
                        UTCDateToLocalDate(resItem.createTime)
                    ) <=
                    1000 * 60 * 60 &&
                  dataList.deleted != 1
                "
              >
                <md-menu md-direction="bottom-end">
                  <md-button class="md-icon-button" md-menu-trigger>
                    <i class="iconfont iconmore_vert-24px" />
                  </md-button>
                  <md-menu-content>
                    <md-menu-item
                      v-if="
                        $buttonPermission('Messages', 'Full') ||
                        $buttonPermission('Messages', 'Edit')
                      "
                      @click="onEditReply(resItem, index)"
                      :disabled="
                        Date.now() -
                          Date.parse(
                            UTCDateToLocalDate(resItem.modifyTime) ||
                              UTCDateToLocalDate(resItem.createTime)
                          ) >
                        1000 * 60 * 60
                      "
                      >Edit</md-menu-item
                    >
                    <md-menu-item
                      v-if="$buttonPermission('Messages', 'Full')"
                      @click="onDelReply(resItem.id)"
                      :disabled="
                        Date.now() -
                          Date.parse(
                            UTCDateToLocalDate(resItem.modifyTime) ||
                              UTCDateToLocalDate(resItem.createTime)
                          ) >
                        1000 * 60 * 60
                      "
                      >Delete</md-menu-item
                    >
                  </md-menu-content>
                </md-menu>
              </span>
            </div>
            <div class="msg-cot">
              <!--            <p v-if="resItem._isEdit === true" v-html=" $escape2Html(resItem.response) "></p>-->
              <p v-if="resItem.deleted == 1" class="txts">This reply has been deleted.</p>
              <div
                v-else-if="resItem._isEdit === true"
                class="richT richT1"
                v-loading="resItem.loading"
              >
                <!--              <div class="send" @click="onReply" :class="{send1:replyData}" :style="{bottom:fileList.length?'88px':'8px'}">Send</div>-->
                <RichText
                  :key="'reply-' + resItem.id + '-' + resItem._editSession"
                  :content="resItem._repleyValue"
                  v-on="resItem._editorEvents"
                  :enable-video="true"
                  :isSureBtnDisabled="!!resItem.loading"
                  :inert="resItem.loading ? '' : null"
                  contentHeight="160px"
                  height="110px"
                  class="richText"
                  :class="{ 'editor-disabled': resItem.loading }"
                  :upload="true"
                  :currentIndex="index"
                  :ref="'richTextReply' + resItem.id"
                >
                </RichText>
                <div class="errorTxt edit-error" v-if="contentError(resItem._repleyValue)">
                  {{ contentError(resItem._repleyValue) }}
                </div>
                <div class="upData" v-if="resItem._fileObject && resItem._fileObject.length > 0">
                  <div v-for="(file, ind) in resItem._fileObject" :key="ind" class="upCon">
                    <div class="upCon-c1">
                      <img
                        v-if="
                          file.src && (file.src.indexOf('png') > -1 || file.src.indexOf('jpg') > -1)
                        "
                        :src="file.src"
                        alt=""
                      />
                      <i v-else class="iconfont iconupload"></i>
                    </div>

                    <div class="upCon-c2">
                      <p class="upName">{{ file.fileName }}</p>
                      <p class="upSize" v-if="file.size">({{ Math.floor(file.size / 1024) }}K)</p>
                    </div>

                    <div class="upCon-c3">
                      <el-button
                        type="text"
                        icon="el-icon-close"
                        @click="clearItemFile(resItem, ind)"
                      ></el-button>
                    </div>
                    <!--          {{file.fileName}}-->
                  </div>
                </div>
                <div class="btns">
                  <div class="btns-cancel" @click="cancelReply(resItem)">Cancel</div>

                  <div
                    class="btns-save"
                    @click="saveReply(resItem)"
                    :aria-disabled="!canSaveReply(resItem)"
                    :class="{
                      'btns-save1': canSaveReply(resItem)
                    }"
                  >
                    Save
                  </div>
                </div>
              </div>
              <div v-else class="txts" v-html="getMessageR(resItem.response)"></div>
            </div>
            <div class="msg-file" v-if="resItem.fileObject && !resItem._isEdit">
              <div
                v-for="(file, ind) in parseFileObject(resItem.fileObject)"
                :key="ind"
                class="upCon"
                @click="toDown(file.src)"
              >
                <div class="upCon-c1">
                  <img
                    v-if="
                      file.src && (file.src.indexOf('png') > -1 || file.src.indexOf('jpg') > -1)
                    "
                    :src="file.src"
                    alt=""
                  />
                  <i v-else class="iconfont iconupload"></i>
                </div>
                <el-tooltip
                  popper-class="customer-number-tooltip-popover table-tooltip"
                  :content="file.fileName"
                  placement="top"
                  :visible-arrow="false"
                >
                  <div class="upCon-c2">
                    <p class="upName">{{ file.fileName }}</p>
                  </div>
                </el-tooltip>
                <div class="upCon-c3">
                  <p class="upSize" v-if="file.size">({{ Math.floor(file.size / 1024) }}K)</p>
                </div>
                <!--          {{file.fileName}}-->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="canReply" class="richT" v-loading="loadReply" id="reply">
        <div class="richT-head" id="replyDrag">
          <div class="richT-head-flex">
            <span class="iconfont iconwhatsapp_msg"></span>
            <p>Commbook</p>
            <p class="line"></p>
          </div>
          <span class="iconfont icondrag"></span>
          <span class="richT-head-flex"></span>
        </div>
        <div
          class="send"
          @click="onReply"
          :class="{ send1: canSendReply }"
          :aria-disabled="!canSendReply"
          :style="{ bottom: fileList.length ? '8px' : '8px' }"
        >
          Send
        </div>
        <RichText
          :key="conversationIdentity"
          :content="replyData"
          v-on="replyEditorEvents"
          :enable-video="true"
          :isSureBtnDisabled="loadReply"
          :inert="loadReply ? '' : null"
          :height="getRichH()"
          :contentHeight="getRichH1()"
          class="richText"
          :class="{ 'editor-disabled': loadReply }"
          :upload="true"
          ref="richText"
        >
        </RichText>
        <div class="errorTxt" v-if="contentError(replyData)">{{ contentError(replyData) }}</div>
        <div class="upData" v-if="fileList.length > 0">
          <div v-for="(file, index) in fileList" :key="index" class="upCon">
            <div class="upCon-c1">
              <img
                v-if="file.src.includes('png') || file.src.includes('jpg')"
                :src="file.src"
                alt=""
              />
              <i v-else class="iconfont iconupload"></i>
            </div>

            <div class="upCon-c2">
              <p class="upName">{{ file.fileName }}</p>
              <p class="upSize" v-if="file.size">({{ Math.floor(file.size / 1024) }}K)</p>
            </div>
            <div class="upCon-c3">
              <el-button type="text" icon="el-icon-close" @click="clearFile(index)"></el-button>
            </div>
            <!--          {{file.fileName}}-->
          </div>
        </div>
      </div>
    </GgPage>

    <Snackbar :visible.sync="snackbar.isShow" :content="snackbar.content" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { Ajax, Utils } from '@/common'
import moment from 'moment/moment'

import RichText from '@/views/announcement/RichText/RichText1.vue'
import {
  decodeCommbookHtml,
  getCommbookContent,
  validCommbookContent
} from '@/common/video/commbookContent'

export default {
  components: {
    RichText
  },
  data() {
    return {
      name: '',
      currentIndex: 0,
      inputData: '',
      isShowRecipientsView: false,
      firstName: '',
      loading: false,
      dataList: '',
      defaultData: '',
      conversationDataIdentity: '',
      conversationEpoch: 0,
      conversationRequest: 0,
      editorHeightC: '110px',
      editorHeight: 110,
      pagesTotal: 0,
      replyData: '',
      fileList: [],
      loadReply: false,
      replyVideoUploading: false,
      replyEditorEvents: {},
      editSession: 0,
      titleHeight: '20px',
      snackbar: {
        isShow: false,
        content: ''
      }
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.user
    }),
    canReply() {
      const permissions = this.user.rolePermission
      return (
        Array.isArray(permissions) &&
        permissions.includes('Commbook') &&
        (permissions.includes('Messages_Full') || permissions.includes('Messages_Edit'))
      )
    },
    canSendReply() {
      return (
        this.canReply &&
        !this.loadReply &&
        !this.replyVideoUploading &&
        validCommbookContent(this.replyData, this.fileList)
      )
    },
    canSaveMessage() {
      return !!this.dataList && this.canSaveEdit(this.dataList, true)
    },
    messageClass() {
      return {
        'md-invalid': this.hasErrorMessages
      }
    },
    // 会话/学生身份（路由 query 承载）：复用页面时据此判定重取
    conversationIdentity() {
      return `${this.$route.query.id || ''}|${this.$route.query.studentId || ''}`
    }
  },
  created() {
    this.resetReplyEditorEvents()
    this.getData()
    this.setRead()
  },
  watch: {
    canReply(allowed) {
      if (allowed) this.$nextTick(() => this.setDragEvent())
    },
    // 详情页被 A→B 复用（query.id/studentId 变化）：按新身份重取，过期响应按请求身份丢弃
    conversationIdentity() {
      // 草稿、附件及发送态只属于打开时的学生；编辑器按身份重建，旧上传回调不能串入新会话。
      this.conversationEpoch++
      this.replyData = ''
      this.fileList = []
      this.loadReply = false
      this.replyVideoUploading = false
      this.resetReplyEditorEvents()
      this.currentIndex = 0
      this.dataList = ''
      this.defaultData = ''
      this.conversationDataIdentity = ''
      this.getData()
      this.setRead()
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setDragEvent()
    })
  },
  methods: {
    contentCount(value) {
      return getCommbookContent(value).characterCount
    },
    contentError(value) {
      const content = getCommbookContent(value)
      if (content.characterCount > 4000) return 'Character limit of 4000'
      return content.hasInvalidMedia ? 'Finish uploading or remove the unfinished media' : ''
    },
    isCurrentConversation(identity, epoch) {
      return (
        !this._isDestroyed &&
        !this._isBeingDestroyed &&
        identity === this.conversationIdentity &&
        epoch === this.conversationEpoch
      )
    },
    resetReplyEditorEvents() {
      const identity = this.conversationIdentity
      const epoch = this.conversationEpoch
      this.replyEditorEvents = {
        setHtml: (html) => {
          if (this.isCurrentConversation(identity, epoch) && !this.loadReply) this.setComment(html)
        },
        setFile: (file) => {
          if (this.isCurrentConversation(identity, epoch) && !this.loadReply) this.setFile(file)
        },
        'uploading-change': (uploading) => {
          if (this.isCurrentConversation(identity, epoch)) this.replyVideoUploading = uploading
        }
      }
    },
    isCurrentEdit(record, main, session = record._editSession) {
      return (
        !!record &&
        record._isEdit &&
        record._editSession === session &&
        this.isCurrentConversation(record._editIdentity, record._editEpoch) &&
        (main
          ? this.dataList === record
          : !!this.dataList && (this.dataList.responseDTOList || []).includes(record))
      )
    },
    canSaveEdit(record, main) {
      return (
        this.isCurrentEdit(record, main) &&
        !record.loading &&
        !record._videoUploading &&
        validCommbookContent(main ? record._message : record._repleyValue, record._fileObject || [])
      )
    },
    canSaveReply(record) {
      return this.canSaveEdit(record, false)
    },
    beginEdit(record, main) {
      if (this.loading || record._isEdit || record.loading) return
      const session = ++this.editSession
      this.$set(record, '_editSession', session)
      this.$set(record, '_editIdentity', this.conversationIdentity)
      this.$set(record, '_editEpoch', this.conversationEpoch)
      this.$set(record, '_videoUploading', false)
      this.$set(record, 'loading', false)
      this.$set(
        record,
        main ? '_message' : '_repleyValue',
        decodeCommbookHtml(main ? record.message : record.response)
      )
      this.$set(record, '_fileObject', this.parseFileObject(record.fileObject).slice())
      this.$set(record, '_isEdit', true)
      this.$set(record, '_editorEvents', {
        setHtml: (html) => {
          if (this.isCurrentEdit(record, main, session) && !record.loading) {
            this.$set(record, main ? '_message' : '_repleyValue', html === '<p></p>' ? '' : html)
          }
        },
        setFile: (file) => {
          if (this.isCurrentEdit(record, main, session) && !record.loading)
            record._fileObject.push(file)
        },
        'uploading-change': (uploading) => {
          if (this.isCurrentEdit(record, main, session)) record._videoUploading = uploading
        }
      })
    },
    setEditorEditable(refName, editable) {
      const reference = this.$refs[refName]
      const component = Array.isArray(reference) ? reference[0] : reference
      if (component && component.editor && !component.editor.isDestroyed) {
        component.editor.setEditable(editable)
      }
    },
    cancelEdit(record, main) {
      if (!this.isCurrentEdit(record, main) || record.loading) return
      const reference = this.$refs[main ? 'richTextMessage' : 'richTextReply' + record.id]
      const component = Array.isArray(reference) ? reference[0] : reference
      if (component && component.videoUploadController) component.videoUploadController.cancel()
      record._isEdit = false
    },
    getRichH() {
      if (this.fileList.length > 0) {
        return this.editorHeight + 'px'
      } else {
        return this.editorHeight + 'px'
      }
    },
    getRichH1() {
      if (this.fileList.length > 0) {
        return this.editorHeight + 50 + 70 + 'px'
      } else {
        return this.editorHeight + 50 + 'px'
      }
    },
    toDown(src) {
      window.open(src)
    },
    setDragEvent() {
      let dragEle = document.getElementById('replyDrag')
      let targetEle = document.getElementById('reply')
      if (!dragEle || !targetEle) return
      let that = this
      dragEle.onmousedown = function (ev) {
        let mouseDownY = ev.clientY
        let T0 = targetEle.offsetTop
        let areaT = T0 + 20
        let changeT = mouseDownY < areaT
        let height = targetEle.offsetHeight
        console.log('setDragEvent1', mouseDownY, T0)
        console.log(areaT)
        document.onmousemove = function (ev) {
          // 鼠标移动时的鼠标位置
          let mouseMoveY = ev.clientY
          that.showReplyMask = true
          let maskHeight = height + (T0 - mouseMoveY) + 100
          if (maskHeight < 110) {
            that.maskHeight = 110
          } else if (maskHeight > 400) {
            that.maskHeight = 400
          } else {
            that.maskHeight = maskHeight
          }
          console.log('setDragEvent', that.maskHeight, mouseMoveY, T0, T0 - mouseMoveY)
          if (changeT) {
          }
        }
        document.onmouseup = function () {
          //鼠标离开时清除事件
          console.log(that.maskHeight)
          document.onmousemove = null
          that.editorHeightC = that.maskHeight - 45 + 'px'
          that.editorHeight = that.maskHeight - 45

          that.showReplyMask = false
        }
        return false
      }
    },
    setMessage(html) {
      if (html === '<p></p>') {
        html = ''
      }
      this.dataList._message = html
    },
    setMessageFile(file) {
      console.log(5555)
      console.log(file)

      this.dataList._fileObject.push(file)
    },
    _canWriteConversation() {
      if (
        !this.$route.query.id ||
        !this.$route.query.studentId ||
        this.conversationDataIdentity !== this.conversationIdentity
      ) {
        this.snackbar = {
          isShow: true,
          content: 'Conversation data is not ready yet, please try again'
        }
        return false
      }
      return true
    },
    async savedataList() {
      if (!this.canSaveMessage || !this._canWriteConversation()) return
      const record = this.dataList
      const session = record._editSession
      const params = {
        ...this.defaultData,
        pubUserId: this.user.userId,
        pubUserType: 2,
        schoolId: this.user.locationId,
        // 学生身份在 query（路由 /commbook/studentResponse 无 :studentId 参数段，
        // studentsList toDetail 传 query.studentId，onReply 同源）：params 读法恒为 [undefined]→载荷 [null]
        studentIdList: [this.$route.query.studentId],
        message: record._message,
        fileObject: record._fileObject.length ? JSON.stringify(record._fileObject) : ''
      }
      record.loading = true
      this.setEditorEditable('richTextMessage', false)
      try {
        const res = await Ajax.post('/commbook/title/update', params)
        if (!this.isCurrentEdit(record, true, session)) return
        if (!res || res.code !== '0000')
          throw new Error((res && res.message) || 'Unable to save. Please try again.')
        this.snackbar = { isShow: true, content: res.message || 'Message saved' }
        record.loading = false
        record._isEdit = false
        this.getData()
      } catch (error) {
        if (this.isCurrentEdit(record, true, session)) {
          this.snackbar = {
            isShow: true,
            content: error.message || 'Unable to save. Please try again.'
          }
        }
      } finally {
        if (this.isCurrentEdit(record, true, session)) {
          record.loading = false
          this.setEditorEditable('richTextMessage', true)
        }
      }
    },
    canceldataList() {
      this.cancelEdit(this.dataList, true)
    },
    clearItemFileMessage(ind) {
      if (!this.dataList.loading) this.dataList._fileObject.splice(ind, 1)
    },
    // fileObject 是 JSON 字符串（getData 拼装）：坏形状判空/try，渲染与编辑均不炸
    parseFileObject(fileObject) {
      if (!fileObject) return []
      if (Array.isArray(fileObject)) return fileObject
      try {
        const parsed = JSON.parse(fileObject)
        return Array.isArray(parsed) ? parsed : []
      } catch (err) {
        return []
      }
    },
    onDelTopic(id) {
      this.$confirm(
        'Once deleted, parents cannot see this message and comments will also be deleted.',
        'Delete conversation?',
        {
          cancelButtonText: 'Cancel',
          confirmButtonText: 'Delete',
          cancelButtonClass: 'gg_cancel_button',
          confirmButtonClass: 'gg_submit_button',
          customClass: 'gg_confirm',
          showClose: false
        }
      ).then(() => {
        this.delTopic(id, true)
      })
    },
    delTopic(id) {
      let params = {
        id,
        userId: this.user.userId // '3fa7f627dda84f3e914f79863e0eda0b'
      }
      Ajax.post('/commbook/title/delete', {}, {}, params).then((res) => {
        this.getData()
        this.snackbar = {
          isShow: true,
          content: 'Conversation has been deleted'
        }
      })
    },
    onEditConversationSave() {
      this.beginEdit(this.dataList, true)
    },
    htmlDecode(text) {
      return decodeCommbookHtml(text)
    },
    cancelReply(record) {
      this.cancelEdit(record, false)
    },
    async saveReply(resItem) {
      if (!this.canSaveReply(resItem) || !this._canWriteConversation()) return
      const session = resItem._editSession
      const params = {
        id: resItem.id,
        commbookId: this.dataList.id,
        pubUserId: this.dataList.pubUserId,
        response: resItem._repleyValue,
        responseUser: this.user.userId, // '3fa7f627dda84f3e914f79863e0eda0b'
        responseUserType: 2,
        fileList: [],

        fileObject: resItem._fileObject.length > 0 ? JSON.stringify(resItem._fileObject) : '',
        fileDisplayNameList: ['']
      }
      resItem.loading = true
      this.setEditorEditable('richTextReply' + resItem.id, false)
      try {
        const res = await Ajax.post('/commbook/response/update', params)
        if (!this.isCurrentEdit(resItem, false, session)) return
        if (!res || res.code !== '0000')
          throw new Error((res && res.message) || 'Unable to save. Please try again.')
        resItem.loading = false
        resItem._isEdit = false
        this.getData()
      } catch (error) {
        if (this.isCurrentEdit(resItem, false, session)) {
          this.snackbar = {
            isShow: true,
            content: error.message || 'Unable to save. Please try again.'
          }
        }
      } finally {
        if (this.isCurrentEdit(resItem, false, session)) {
          resItem.loading = false
          this.setEditorEditable('richTextReply' + resItem.id, true)
        }
      }
    },
    onDelReply(id) {
      this.$confirm(
        'Once deleted, parents cannot see this message and you will not be able to recover the data.',
        'Delete reply?',
        {
          cancelButtonText: 'Cancel',
          confirmButtonText: 'Delete',
          cancelButtonClass: 'gg_cancel_button',
          confirmButtonClass: 'gg_submit_button',
          customClass: 'gg_confirm',
          showClose: false
        }
      ).then(() => {
        this.delReply(id)
      })
    },
    delReply(id) {
      let params = {
        id,
        userId: this.user.userId // '3fa7f627dda84f3e914f79863e0eda0b'
      }
      Ajax.post('/commbook/response/delete', {}, {}, params).then((res) => {
        this.getData()
        this.snackbar = { isShow: true, content: res.message }
      })
    },
    onEditReply(resItem, index) {
      this.currentIndex = index
      this.beginEdit(resItem, false)
    },
    toPares(item) {
      console.log(item)
      if (item.indexOf(',') > -1) {
        return item.split(',')
      }
      return [item]
    },
    async onReply() {
      if (!this.canSendReply || !this._canWriteConversation()) return
      const identity = this.conversationIdentity
      const epoch = this.conversationEpoch
      this.loadReply = true
      this.setEditorEditable('richText', false)

      let params = {
        commbookId: this.dataList.id,
        pubUserId: this.dataList.pubUserId,
        response: this.replyData,
        responseUser: this.user.userId, // '3fa7f627dda84f3e914f79863e0eda0b'
        responseUserType: 2,
        fileList: [],
        studentId: this.$route.query.studentId,
        fileDisplayNameList: [''],
        fileObject: this.fileList.length > 0 ? JSON.stringify(this.fileList) : ''
      }
      try {
        const res = await Ajax.post('/commbook/response/response', params)
        if (!this.isCurrentConversation(identity, epoch)) return
        if (!res || res.code !== '0000')
          throw new Error((res && res.message) || 'Unable to send. Please try again.')
        this.getData()
        if (this.$refs.richText) this.$refs.richText.clearHtml()
        this.fileList = []
        this.replyData = ''
      } catch (error) {
        if (this.isCurrentConversation(identity, epoch)) {
          this.snackbar = {
            isShow: true,
            content: error.message || 'Unable to send. Please try again.'
          }
        }
      } finally {
        if (this.isCurrentConversation(identity, epoch)) {
          this.loadReply = false
          this.setEditorEditable('richText', true)
        }
      }
    },
    setComment(html, num, text) {
      console.log('setComment', html, num)
      if (html === '<p></p>') {
        html = ''
      }
      this.replyData = html
    },
    setReply(html, len, text, index) {
      console.log(html)
      if (html === '<p></p>') {
        html = ''
      }
      console.log(index)
      this.dataList.responseDTOList[index]._repleyValue = html
      if (html) {
        // this.dataList.responseDTOList[index]._repleyValue = html;
      }
    },
    setReplyFile(file, index) {
      this.dataList.responseDTOList[index]._fileObject.push(file)
    },
    clearItemFile(record, ind) {
      if (!record.loading) record._fileObject.splice(ind, 1)
    },
    clearFile(index) {
      if (!this.loadReply) this.fileList.splice(index, 1)
    },
    setFile(res) {
      this.fileList.push(res)
      console.log(222)
      console.log(this.fileList)
    },
    UTCDateToLocalDate(dateStr) {
      if (!dateStr) return false
      let date1 = new Date()
      let offsetMinute = date1.getTimezoneOffset()
      let offsetHours = offsetMinute / 60
      let date2 = new Date(dateStr)
      date2.setHours(date2.getHours() - offsetHours)
      return Utils.formatTime(Date.parse(date2))
    },
    getMessageR(item) {
      let message = decodeCommbookHtml(item)
      console.log(1111)
      console.log('getMessage', message)
      if (message) {
        message = message.replace(/<p><\/p>/g, '<br/>')
      }

      return message
    },
    getMessage(item) {
      let message = decodeCommbookHtml(item.message)
      console.log(1111)
      console.log('getMessage', message)
      if (message) {
        message = message.replace(/<p><\/p>/g, '<br/>')
      }

      return message
    },
    timeFormat(date) {
      if (!date) {
        return '-'
      }
      return moment.utc(date).local().format('DD/MM/YYYY, hh:mm A')
    },
    getData() {
      // 请求身份：A→B 复用时丢弃过期响应
      const reqId = this.$route.query.id
      const identity = this.conversationIdentity
      const epoch = this.conversationEpoch
      const request = ++this.conversationRequest
      let params = {
        id: reqId
      }
      this.loading = true
      setTimeout(() => {
        if (!this.isCurrentConversation(identity, epoch) || request !== this.conversationRequest)
          return
        Ajax.get('/commbook/title/getById', params)
          .then((res) => {
            if (
              identity !== this.conversationIdentity ||
              epoch !== this.conversationEpoch ||
              this._isDestroyed ||
              request !== this.conversationRequest
            )
              return
            this.loading = false
            if (res.code !== '0000' || !res.data) return
            if (res.data.file) {
              res.data.fileObject = JSON.stringify([
                {
                  src: res.data.file,
                  fileName: res.data.file.split('/')[res.data.file.split('/').length - 1]
                }
              ])
            }
            let data = []
            if (res.data.responseDTOList) {
              res.data.responseDTOList.forEach((item, index) => {
                if (item.file) {
                  item.fileObject = JSON.stringify([
                    {
                      src: item.file,
                      fileName: item.file.split('/')[item.file.split('/').length - 1]
                    }
                  ])
                }
                if (item.isRead === 1) {
                  data.push(item)
                }
              })
              res.data.responseDTOList.forEach((item, index) => {
                if (item.isRead === 0) {
                  data.push(item)
                }
              })
              res.data.responseDTOList = JSON.parse(JSON.stringify(data))
            }
            this.defaultData = { ...res.data, responseDTOList: undefined }
            const previous = this.dataList
            const previousReplies = (previous && previous.responseDTOList) || []
            res.data.responseDTOList = (res.data.responseDTOList || []).map((record) => {
              const editing = previousReplies.find((old) => old.id === record.id && old._isEdit)
              return editing ? Object.assign(editing, record) : record
            })
            if (previous && previous.id === res.data.id && previous._isEdit) {
              Object.assign(previous, res.data)
              this.dataList = previous
            } else {
              this.dataList = res.data
            }
            this.conversationDataIdentity = identity
            console.log(111)
            console.log(this.dataList)
            this.$nextTick(() => {
              if (!this.isCurrentConversation(identity, epoch) || !this.$refs.titleH) return
              this.titleHeight = this.$refs.titleH.offsetHeight + 'px'

              var scrollTarget = document.getElementById('scrollDiv')

              if (scrollTarget) scrollTarget.scrollTop = 20000
              //scrollTarget.scrollHeight是获取dom元素的高度，然后设置scrollTop
            })
            // for (let i = records.length - 1; i >= 0; i--) {
            //   this.dataList.unshift(records[i]);
            // }
          })
          .catch((error) => {
            if (
              !this.isCurrentConversation(identity, epoch) ||
              request !== this.conversationRequest
            )
              return
            this.loading = false
            this.snackbar = {
              isShow: true,
              content: error.message || 'Unable to refresh the conversation.'
            }
          })
      }, 800)
    },
    setRead() {
      let params = {
        id: this.$route.query.id
      }
      Ajax.get('/commbook/title/readById', params).then((res) => {
        // for (let i = records.length - 1; i >= 0; i--) {
        //   this.dataList.unshift(records[i]);
        // }
      })
    }
  }
}
</script>

<style lang="less">
.studentResponse {
  .editor-disabled {
    pointer-events: none;
  }
  .edit-error {
    position: static;
    margin-top: 8px;
  }
  .txts {
    overflow-wrap: break-word;
    video {
      max-width: 100%;
      height: auto;
    }
    ul,
    ol {
      padding: 0 1rem;
    }
    ul {
      list-style: disc !important;
    }
  }
  .ggPage-main-center-content {
    position: relative;
  }
  .response {
    .md-menu {
      .md-button {
        width: 20px;
        height: 20px;
        min-width: 20px;
      }
      .md-ripple {
        width: 20px;
        height: 20px;
        margin-top: -8px;
      }
    }
  }
}
</style>

<style scoped lang="less">
.richT1 {
  position: relative !important;
  bottom: 0 !important;
}
.richT {
  position: absolute;
  bottom: 72px;
  width: 100%;
  .send {
    position: absolute;
    width: 60px;
    cursor: pointer;
    text-align: center;
    line-height: 32px;
    background-color: #eaf0f6;
    border-radius: 2px;
    color: #b0c1d4;
    right: 8px;
    bottom: 8px;
    z-index: 20;
    font-size: 12px;
    font-family: OpenSans;
  }
  .send1 {
    background-color: #2b7de9;
    color: #fff;
  }
  .richText {
    position: relative;
  }
  .errorTxt {
    color: #ea4335;
    font-size: 12px;
    position: absolute;
  }
  .upData {
    display: flex;
    width: 100%;
    padding: 0px 12px;
    overflow-x: auto;
  }
  .upCon {
    width: 200px;
    height: 58px;
    position: absolute;
    bottom: 60px;
    display: flex;
    border: 1px solid #eaf0f6;
    padding: 8px 12px;
    background-color: #f5f8fa;
    margin-right: 22px;
    &-c1 {
      width: 20px;
      display: flex;
      align-items: center;
      .iconfont {
        font-size: 20px;
        color: #33475b;
      }
      img {
      }
    }
    &-c2 {
      width: 116px;
      margin: 0 12px;
      .upName {
        color: #33475b;
        font-family: OpenSans-Bold;
        width: 110px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        line-height: 20px;
      }
      .upSize {
        color: #516f90;
        font-family: OpenSans;

        line-height: 20px;
      }
    }

    &-c3 {
      .el-button {
        height: 20px;
        font-weight: 700;
        font-size: 16px;
        padding: 0;

        color: #7c98b6;
        .el-icon-close {
        }
      }
    }
  }
  &-head {
    height: 44px;
    width: 100%;
    border: 1px solid #dbdbdb;
    border-bottom: 0px;
    display: flex;
    justify-content: space-between;
    .icondrag {
      transform: rotate(90deg);
      margin-top: -18px;
      color: #516f90;
    }
    &-flex {
      display: flex;
      align-items: center;
      width: 148px;
      color: #202124;
      position: relative;
      .line {
        position: absolute;
        width: 100%;
        height: 4px;
        left: 0;
        bottom: 0;
        border-radius: 3px;
        background-color: #202124;
      }

      .iconfont {
        font-size: 16px;

        margin: 0 16px;
      }
    }
  }
}
.commbook {
  position: relative;
  background-color: #fff !important;
}
.response {
  width: 100%;
  background-color: #fff;
  .msgs {
    padding: 0 20px;
    height: calc(100vh - 500px);
    overflow-y: auto;
    .msg {
      padding-top: 20px;
      &-cot {
        color: #202124;
        padding: 8px 0 0 40px;
      }
      .btns {
        align-items: center;
        display: flex;
        margin-top: 8px;
        &-cancel {
          color: #5f6368;
          font-size: 14px;
          font-family: OpenSans-Bold;
          margin-right: 20px;
        }
        &-save {
          background-color: #eeeeee;
          border-radius: 4px;
          width: 56px;
          text-align: center;
          line-height: 36px;
          color: #b4b4b4;
          font-size: 14px;
          font-family: OpenSans-Bold;
          cursor: not-allowed;
        }
        &-save1 {
          cursor: pointer;
          background-color: #1a73e8;
          color: #fff;
        }
      }
      &-file {
        margin-left: 40px;
        margin-top: 8px;

        .upCon {
          width: 300px;
          height: 36px;
          display: flex;
          border: 1px solid #eaf0f6;
          padding: 8px 12px;
          background-color: #f5f8fa;
          margin-bottom: 8px;
          &-c1 {
            width: 20px;
            display: flex;
            align-items: center;
            .iconfont {
              font-size: 20px;
              color: #33475b;
            }
            img {
            }
          }
          .upSize {
            color: #516f90;
            font-family: OpenSans;

            line-height: 20px;
          }
          &-c2 {
            width: 180px;
            margin: 0 12px;
            .upName {
              color: #33475b;
              font-family: OpenSans-Bold;
              width: 180px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              line-height: 20px;
            }
          }

          &-c3 {
            .el-button {
              height: 20px;
              font-weight: 700;
              font-size: 16px;
              padding: 0;

              color: #7c98b6;
              .el-icon-close {
              }
            }
          }
        }
      }
      &-header {
        display: flex;
        align-items: center;
        position: relative;
        .menu {
          position: absolute;
          right: 0;
        }
        .name {
          margin: 0 8px;
          font-size: 14px;
          color: #202124;
          font-family: Roboto;
          line-height: 32px;
        }
        .date {
          color: #b4b4b4;
          font-size: 12px;
          font-family: Roboto;

          line-height: 32px;
        }
        .dot {
          width: 6px;
          height: 6px;
          background-color: #ea4335;
          border-radius: 50%;
          margin-left: 6px;

          line-height: 32px;
        }
      }
    }
  }
  &-header {
    width: 100%;
    //height: 82px;
    border-bottom: 1px solid #e0e0e0;
    .title {
      color: #202124;
      font-size: 22px;
      font-family: OpenSans-Bold;
      margin-bottom: 8px;
      //white-space: nowrap;
      //text-overflow: ellipsis;
      //overflow: hidden;
    }
    .type {
      display: inline-block;
      height: 20px;
      line-height: 20px;
      padding: 0 6px 0;
      margin-bottom: 22px;
      border-radius: 10px;
      background: #e8f0fe;
      color: #1a73e8;
      font-size: 12px;
    }
  }
}
</style>
